module.exports = __webpack_public_path__ + "static/media/directions_transit.71aeb339.svg";